export default __webpack_public_path__ + "static/media/curseofgwahlur.1cc2b9e4.png";